export const Navigation = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.1654 7.99967C14.1654 11.4054 11.4045 14.1663 7.9987 14.1663C4.59294 14.1663 1.83203 11.4054 1.83203 7.99967C1.83203 4.59392 4.59294 1.83301 7.9987 1.83301C11.4045 1.83301 14.1654 4.59392 14.1654 7.99967Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9.76925 5.81983L7.03289 6.56611C6.80515 6.62822 6.62724 6.80613 6.56513 7.03387L5.81885 9.77023C5.75099 10.0191 5.97931 10.2474 6.22814 10.1795L8.9645 9.43324C9.19224 9.37113 9.37016 9.19322 9.43227 8.96548L10.1785 6.22912C10.2464 5.98029 10.0181 5.75196 9.76925 5.81983Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)
